var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 54,
    viewBox: "0 0 71 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_4533)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_4533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H71V54H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_4533)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V54H71V0H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_65_4533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 54
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V54H71V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_65_4533)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_65_4533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 54
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H71V54H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_65_4533)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.90527 50.1409L7.71916 56.8436L71.3529 7.28514L79.5956 -2.67336L62.8884 -4.91211L36.9334 16.4426L16.0417 30.8336L-7.90527 50.1409Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.76855 54.8371L2.19454 58.7251L76.6358 -3.59766H65.46L-5.76634 54.8348L-5.76855 54.8371Z",
    fill: "#F50100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9051 50.1409L63.2807 56.8436L-0.353047 7.28514L-8.5957 -2.67336L8.11148 -4.91211L34.0664 16.4426L54.9582 30.8336L78.9051 50.1409Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.373 53.5114L70.4121 57.3994L38.7151 30.7144L29.3164 27.7354L-9.38965 -2.63965H1.78841L40.4701 27.0154L50.7451 30.5884L78.373 53.5114Z",
    fill: "#F50100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8828 -4.5H27.1179V18H-4.375V36H27.1179V58.5H43.8828V36H75.5V18H43.8828V-4.5Z",
    fill: "#F50100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_65_4533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -5,
    width: 81,
    height: 64
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8828 -4.5H27.1179V18H-4.375V36H27.1179V58.5H43.8828V36H75.5V18H43.8828V-4.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_65_4533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1179 -4.5V-9H22.6804V-4.5H27.1179ZM43.8828 -4.5H48.3203V-9H43.8828V-4.5ZM27.1179 18V22.5H31.5554V18H27.1179ZM-4.375 18V13.5H-8.8125V18H-4.375ZM-4.375 36H-8.8125V40.5H-4.375V36ZM27.1179 36H31.5554V31.5H27.1179V36ZM27.1179 58.5H22.6804V63H27.1179V58.5ZM43.8828 58.5V63H48.3203V58.5H43.8828ZM43.8828 36V31.5H39.4453V36H43.8828ZM75.5 36V40.5H79.9375V36H75.5ZM75.5 18H79.9375V13.5H75.5V18ZM43.8828 18H39.4453V22.5H43.8828V18ZM27.1179 0H43.8828V-9H27.1179V0ZM31.5554 18V-4.5H22.6804V18H31.5554ZM-4.375 22.5H27.1179V13.5H-4.375V22.5ZM0.0625 36V18H-8.8125V36H0.0625ZM27.1179 31.5H-4.375V40.5H27.1179V31.5ZM31.5554 58.5V36H22.6804V58.5H31.5554ZM43.8828 54H27.1179V63H43.8828V54ZM39.4453 36V58.5H48.3203V36H39.4453ZM75.5 31.5H43.8828V40.5H75.5V31.5ZM71.0625 18V36H79.9375V18H71.0625ZM43.8828 22.5H75.5V13.5H43.8828V22.5ZM39.4453 -4.5V18H48.3203V-4.5H39.4453Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_4533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 54,
    rx: 5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk-flag.7c015ce343d680f31e74895be7346c29.svg";
export { ForwardRef as ReactComponent };